import apiFetch from '@wordpress/api-fetch';
import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';
import { initSlider } from '../../component-library/slider/slider-script';
import PostSliderBlogItem from './includes/post-slider-blog-item';
import PostSliderItem from './includes/post-slider-item';

const loadPosts = (postType) => {
	const postTypeSlug = postType === 'post' ? 'posts' : postType;
	const extraParams = postType === 'post' ? '' : 'orderby=menu_order';
	return apiFetch({
		path: `/wp-json/wp/v2/${postTypeSlug}?${extraParams}&order=asc&_fields=id,title,link,type,date,meta.featured_media,_embedded,_links.wp:featuredmedia&_embed=wp:featuredmedia`,
	});
};

const initPostSlider = (sliderEl, slides) => {
	const windowGutter = 'var(--window-gutter)';
	const slider = initSlider(sliderEl, {
		perPage: 3.3,
		focus: 0,
		trimSpace: 'move',
		padding: {
			left: windowGutter,
			right: windowGutter,
		},
		breakpoints: {
			1440: {
				padding: {
					left: 'var(--wp--style--root--padding-left)',
					right: 'var(--wp--style--root--padding-right)',
				},
			},
			1024: {
				perPage: 2.3,
			},
			767: {
				perPage: 1.1,
			},
		},
	});
	slides.forEach((element) => {
		slider.add(element);
	});
};

document.querySelectorAll('.post-slider__slider').forEach((sliderEl) => {
	const { postType } = sliderEl.parentElement.dataset;
	const { mediaAspectRatio } = sliderEl.parentElement.dataset;
	const Item = postType === 'post' ? PostSliderBlogItem : PostSliderItem;
	loadPosts(postType).then((posts) => {
		const container = document.createElement('div');
		const root = createRoot(container);
		flushSync(() => {
			root.render(
				<>
					{posts.map((post) => (
						<Item
							key={post.id}
							post={post}
							mediaAspectRatio={mediaAspectRatio}
							isLinked
						/>
					))}
				</>
			);
		});
		const slides = Array.from(container.children);
		initPostSlider(sliderEl, slides);
	});
});
